var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgClose = function SvgClose(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 7.55664L17.5686 18.6936L6.43164 7.55664ZM16.7731 6.76115C17.2124 6.32181 17.9247 6.32181 18.3641 6.76115C18.8034 7.20049 18.8034 7.9128 18.3641 8.35214L13.5906 13.1246L18.3641 17.8981C18.8034 18.3374 18.8034 19.0497 18.3641 19.4891C17.9247 19.9284 17.2124 19.9284 16.7731 19.4891L11.9996 14.7156L7.22714 19.4891C6.81918 19.897 6.17585 19.9262 5.73427 19.5765L5.63615 19.4891C5.19681 19.0497 5.19681 18.3374 5.63615 17.8981L10.4086 13.1246L5.63615 8.35214C5.19681 7.9128 5.19681 7.20049 5.63615 6.76115C6.07549 6.32181 6.7878 6.32181 7.22714 6.76115L11.9996 11.5336L16.7731 6.76115Z",
    fill: "#797979"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.ac1d94554fbc24011441aa1513b5fbbd.svg";